import React, { memo } from 'react';
import { CardkeeperLogo } from './CardkeeperLogo';
import { usePostHog } from 'posthog-js/react';
export function HeroSection() {
  const posthog = usePostHog();
  const handleCTAClick = () => {
    posthog?.capture('cta_clicked', {
      location: 'hero',
      button_text: 'Get the iOS App'
    });
    document.getElementById('waitlist')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full bg-[#FAF8F5] px-6 py-16 md:py-24 flex flex-col items-center text-center" data-id="element-88">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-89">
        <div className="mb-8 md:mb-12" data-id="element-90">
          <CardkeeperLogo size={120} showWordmark={true} data-id="element-91" />
        </div>

        <h1 className="font-['DM_Sans'] text-4xl md:text-5xl lg:text-6xl font-medium text-[#3A3A3A] leading-[1.15] mb-6 tracking-tight" data-id="element-92">
          Never throw away a holiday card again
        </h1>

        <p className="text-lg md:text-xl text-[#3A3A3A]/80 leading-relaxed max-w-2xl mb-10" data-id="element-93">
          Save and organize every card you receive—by family, over time—so the
          memories last forever.
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-94">
          <button onClick={handleCTAClick} className="bg-[#2D4A3E] text-[#FAF8F5] px-8 py-4 rounded-full font-medium text-lg shadow-md hover:shadow-lg hover:scale-105 transition-all duration-200 active:scale-95" data-id="element-95">
            Get the iOS App
          </button>
          <span className="text-[#B8A99A] text-sm font-medium tracking-wide" data-id="element-96">
            Launching soon on iOS
          </span>
        </div>
      </div>
    </section>;
}